import { motion } from "framer-motion";

export default function Intro() {
  return (
    <motion.div
      className="hero-grid-bg fixed inset-0 z-[100] flex items-center justify-center bg-ice"
      initial={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid="intro-overlay"
    >
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-mint/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-skycyan/15 blur-3xl" />
      <motion.img
        src="/images/logo.webp"
        alt="PocketBima — Chhoti Pocket, Badi Suraksha"
        initial={{ opacity: 0, scale: 0.72, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-60 sm:w-72 md:w-80"
        data-testid="intro-logo"
      />
    </motion.div>
  );
}
